import {wsInstance, NODE_ENV} from '@/utils/common'

const baseMixin = {
    props: {
        rate: {
            type: Number,
            default: 1
        },
        pageConfig: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            type: 'loginForm',
            verifyCodeUrl: '',
            NODE_ENV: NODE_ENV
        }
    },
    components: {
        fanjian: () => import('../components/fanjian.vue'),
        qrCode: () => import('../components/qrCode.vue')
    },
    mounted() {
        this.setRate()
        this.getVerifyCodeUrl()
    },
    watch: {
        rate(newVal) {
            if (newVal) {
                this.setRate()
            }
        }
    },
    methods: {
        changeType(type) {
            this.type = type
            setTimeout(() => {
                this.resetForm(type)
            }, 10)
            this.$emit('changeType', type)
        },
        getVerifyCodeUrl() {
            this.verifyCodeUrl = wsInstance + '/IOT-SERVER-SYSTEM3/auth/user/pass/verifyCode?timeStamp=' + new Date().getTime();
        },
        getVerificationCode(name) {
            this.$httpSys.post("smsAliyun/pass/aliyun/senderCodeAuthMsg?username=" + name).then(data => {
                if (data.code == 200 && data.status == 200) {
                    //发送成功
                    this.$message({message: this.$t(data.data), type: 'success'})
                    this.time = 120;
                    let inter = setInterval(() => {
                        this.time--;
                        if (this.time == 0) {
                            clearInterval(inter)
                        }
                    }, 1000)
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName] && this.$refs[formName].resetFields();
        },
        setRate() {
            //const rate = this.rate
            // this.$refs.loginWrapper.style.transform = `scale(${rate},${rate})`
            // this.$refs.loginWrapper.style.webkitTransform = `scale(${rate},${rate})`
            // this.$refs.loginWrapper.style.msTransform = `scale(${rate},${rate})`
        },
        specialChart(rule, value, callback) {
            var sz = /[%&$#@^*/\\()<>{}[\] ]/gi;//常见的特殊字符不够[]里面继续加
            if (sz.test(value)) {
                callback(new Error(this.$t('不能包含特殊字符')));
            } else {
                callback();
            }
        },
        emitChangeFanjian() {
            this.$emit('changeFanjian')
        },
    }
}

export default baseMixin